// API configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Admin KB API configuration
const ADMIN_API_BASE_URL = process.env.REACT_APP_ADMIN_API_BASE_URL || 'https://ccv76evyok.execute-api.ap-southeast-2.amazonaws.com/prod';
const ADMIN_API_KEY = process.env.REACT_APP_ADMIN_API_KEY || '';

export { API_BASE_URL, ADMIN_API_BASE_URL, ADMIN_API_KEY };